import http from "../http/http-config";
import { SaveMultiQuoteNotificationsResponse } from "../models/saveMultiQuoteNotificationsResponse";
import { SaveMultiQuoteNotificationsRequest } from '../models/saveMultiQuoteNotificationsRequest';

export default new class SaveMultiQuoteNotificationsService {
    saveMultiQuoteNotifications(model: SaveMultiQuoteNotificationsRequest | null): Promise<SaveMultiQuoteNotificationsResponse> {
        return http.post<SaveMultiQuoteNotificationsResponse>("SaveMultiQuoteNotifications", model).then(response => response.data);
    }

    saveMultiQuoteNotificationsFromSession(stepDataKey: string = "stepOneData"): Promise<SaveMultiQuoteNotificationsResponse> {
        const planData = JSON.parse(sessionStorage.getItem("PlanSelected") || "null");
        const clientData = JSON.parse(sessionStorage.getItem(stepDataKey) || "null");

        const request = new SaveMultiQuoteNotificationsRequest();

        request.lastName = clientData.lastName;
        request.firstName = clientData.firstName ? clientData.firstName : "";
        request.phone = clientData.areaCode + clientData.telephone;
        request.mail = clientData.email;
        request.quotePlan = planData.planDescription ? planData.planDescription : planData.PlanName;
        request.step = "client";

        return this.saveMultiQuoteNotifications(request);
    }
}